import React from "react";
import styled from "styled-components";

const BadgeWrapper = styled.div<{ color: string, paintLabel: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11.5px;
  padding: 2px 8px 2px 6px;
  font-weight: 500;
  color: ${({color, paintLabel}) => paintLabel ? color : "var(--text-color)"};
  background-color: rgba(31, 31, 31, 1);
  border-radius: 16px;
  transition: 0.2s;
  &:hover {
  cursor: pointer;
  background-color: rgba(41, 41, 41, 1);
  transition: 0.2s;
  }
`;

const Circle = styled.div<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  flex-shrink: 0;
`;

const Label = styled.span`
  display: flex;
  align-items: center; /* выравнивание текста по центру относительно кружка */
`;

type BadgeProps = {
  color: string; // цвет кружка
  label: string; // текст справа
  paintLabel: boolean;
  onClick?: () => void; // обработчик клика
};

export const Badge: React.FC<BadgeProps> = ({ color, label, onClick, paintLabel=false }) => {
  return (
    <BadgeWrapper color={color} onClick={onClick} paintLabel={paintLabel}>
      <Circle color={color} />
      <Label>{label}</Label>
    </BadgeWrapper>
  );
};
